import React, { useEffect, useRef, useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import './login.css';
import { GetLoginDetailByUserName, SentOtp, VerifyOTP } from "../../_seivices";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import LoadingButton from "../shared/LoadingButton";
import useAsyncSubmit from "../shared/useAsyncSubmit";

const secretKey = "X9f!@#7LwPq8$RtBz3Kq1UvN4TxQ2Zm";

const Login = () => {
    const navigate = useNavigate();
    const [ph, setPh] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [loginDetail, setLoginDetail] = useState(null);
    const [resendTimer, setResendTimer] = useState(0);
    const otpInputRef = useRef(null);
    const { isSubmitting: isAuthSubmitting, run: runAuthSubmit } = useAsyncSubmit();
    const { isSubmitting: isResending, run: runResendSubmit } = useAsyncSubmit();

    const getLoginDetailByMobileNo = async (mobileNo) => {
        try {
            const data = await GetLoginDetailByUserName(mobileNo);
            if (data.isSuccess === 1) {
                setLoginDetail(data.data);
            }
        } catch (error) {
            return null;
        }
    };

    const validatePhoneNumber = (phone) => {
        const isValid = /^\d{10}$/.test(phone) && parseInt(phone[0], 10);
        return isValid;
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');

        if (value !== numericValue) {
            alert("You can enter only numbers.");
        }

        setPh(numericValue.slice(0, 10));

        if (numericValue.length === 10) {
            getLoginDetailByMobileNo(numericValue);
        } else {
            setLoginDetail(null);
        }
    };

    const sendOtp = async () => {
        if (!validatePhoneNumber(ph)) {
            toast.error("Please Enter Valid Mobile Number");
            return;
        }

        const phoneNumber = ph.toString();

        if (!loginDetail) {
            alert("Mobile number is not registered");
            // navigate('/register');
            return;
        }

        await runAuthSubmit(async () => {
            try {
                await SentOtp(phoneNumber);
                setShowOtpInput(true);
                setResendTimer(30);
                toast.success("OTP Sent Successfully");
            } catch (error) {
                return null;
            }
        });
    };

    const verifyOtp = async () => {
        if (!otp) {
            toast.error("Please enter the OTP");
            return;
        }

        // 🟦 Encrypt loginDetail object
        await runAuthSubmit(async () => {
            try {
                const data = await VerifyOTP(ph, otp);
                if (data.isSuccess === 1) {
                    const encryptedData = CryptoJS.AES.encrypt(
                        JSON.stringify(loginDetail),
                        secretKey
                    )?.toString();

                    localStorage.setItem("data", encryptedData);
                    toast.success("OTP Verified Successfully");
                    navigate('/dashboard');
                } else {
                    toast.success(data.message);
                }

            } catch (error) {
                return null;
            }
        });
    };

    const resendOtp = async () => {
        await runResendSubmit(async () => {
            try {
                await SentOtp(ph);
                setResendTimer(30);
                toast.success("OTP Resent Successfully");
            } catch {
                toast.error("Failed to resend OTP");
            }
        });
    };

    useEffect(() => {
        let interval;
        if (resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer((prev) => prev - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [resendTimer]);

    useEffect(() => {
        if (showOtpInput && otpInputRef.current) {
            otpInputRef.current.focus();
        }
    }, [showOtpInput]);

    return (
        <div className="login_main">
            <img src={`/images/bg-dots.png`} alt='' className="login_bg_img" />
            <Toaster />
            <div className="login_form">
                <div className='sidebar_logo_main mb-3 text-center'>
                    <img src="/images/ishivaxlogo.png" alt='' />
                </div>
                <h3 className="text-center mb-3 login_heading">Login</h3>
                {/* <p className="login_subtitle">
                    Login using your registered mobile number
                </p> */}
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group">
                        <label className="mb-2 mobile_label" htmlFor="mobileNo">Mobile Number</label>
                        <input
                            type="text"
                            className="form-control"
                            name="mobile"
                            id="mobile"
                            aria-describedby="emailHelp"
                            placeholder="Enter Mobile Number"
                            value={ph}
                            onChange={handleMobileChange}
                            disabled={showOtpInput}
                            style={{ flex: 1 }}
                            maxLength={10}
                        />
                    </div>
                    {showOtpInput && (
                        <div className="otp_input mt-3">
                            {/* <label className="mb-2 mobile_label" htmlFor="Otp">Otp</label> */}
                            <input
                                ref={otpInputRef}
                                type="text"
                                className="form-control"
                                name="otp"
                                id="otp"
                                placeholder="Enter OTP"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                maxLength={6}
                            />
                        </div>
                    )}
                    <LoadingButton
                        type="submit"
                        className="login_btn"
                        loading={isAuthSubmitting}
                        loadingText={showOtpInput ? 'Verifying...' : 'Sending...'}
                        onClick={showOtpInput ? verifyOtp : sendOtp}
                    >
                        {showOtpInput ? 'Verify OTP' : 'Send OTP'}
                    </LoadingButton>

                    {showOtpInput && (
                        <div className="resend_otp">
                            {resendTimer > 0 ? (
                                <span>Resend OTP in {resendTimer}s</span>
                            ) : (
                                <button type="button" onClick={resendOtp} disabled={isResending}>
                                    {isResending ? 'Resending...' : 'Resend OTP'}
                                </button>
                            )}
                        </div>
                    )}
                </form>
            </div>
        </div>
    )
}

export default Login;
